<ng-container *ngIf="!!get">
    <tt-card>
        <tt-tabs ttRememberId="w_orderhead.gb_orderhead_hours_sub" [(ttSelectedId)]="get.gb_orderhead_hours_sub" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="REGISTRATIONS" ttLabel="gb_orderhead_hours_sub_registrations"></tt-tab>
            <tt-tab ttId="TRANSFER_TO_ORDER" ttLabel="gb_orderhead_hours_sub_transfer_to_order"></tt-tab>
        </tt-tabs>
        <tt-tabs [hidden]="get.gb_orderhead_hours_sub !== 'TRANSFER_TO_ORDER'" [(ttSelectedId)]="selectedTransferTab" (ttSelectedIdChange)="readTransferGrid()">
            <tt-tab ttId="NOTTRANSFERRED" ttLabel="gb_orderhead_hours_sub_transfer_to_order_sub_nottransferred"></tt-tab>
            <tt-tab ttId="TRANSFERRED" ttLabel="gb_orderhead_hours_sub_transfer_to_order_sub_transferred"></tt-tab>
        </tt-tabs>
    </tt-card>
    <tt-powtimes-grid
        [hidden]="get.gb_orderhead_hours_sub !== 'REGISTRATIONS'"
        rememberId="orderhead_hours_sub_registrations_powtime"
        [params]="{ order_internal_no: get.order_internal_no }"
        (gridReady)="powtimesGrid = $event"
    ></tt-powtimes-grid>
    <tt-grid [hidden]="get.gb_orderhead_hours_sub !== 'TRANSFER_TO_ORDER'" *ngIf="!!transferGrid" [(ttOptions)]="transferGrid"></tt-grid>
</ng-container>
